<template>
  <DatePicker v-model="pickedDate" date-format="M d, yy" show-icon fluid />
</template>

<script setup lang="ts">
import { computed } from "vue";
import DatePicker from "primevue/datepicker";

// PrimeVue's DatePicker only speaks `Date`. This component is the single
// boundary where that conversion happens, so callers only ever hold a
// calendar day with no time and no timezone attached to it.
const plainDate = defineModel<Temporal.PlainDate | null>();

const pickedDate = computed<Date | null>({
  get: () => {
    const date = plainDate.value;
    if (!date) return null;
    return new Date(date.year, date.month - 1, date.day);
  },
  set: (date) => {
    plainDate.value = date
      ? new Temporal.PlainDate(
          date.getFullYear(),
          date.getMonth() + 1,
          date.getDate()
        )
      : null;
  },
});
</script>
